$shm_ba_report_renderer $mol_view
	report null $shm_ba_report
	dashboard null $shm_ba_dashboard
	Empty $shm_hitalama_text
		text <= empty_text \
	sub <= rows /
